<template>
  <div class="wrapper">
    <span class="spin-a d1">a</span>
    <span class="spin-a d2">a</span>
    <span class="spin-a d3">a</span>
  </div>
</template>

<script>
export default {
  name: "Spinna"
};
</script>

<style scoped>
.wrapper {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  gap: 8px; /* cleaner spacing instead of manual left offsets */
}

/* Base letter */
.spin-a {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 60px;
  /* height: 80px; */

  font-size: 79px;
  font-family: Arial, sans-serif;
  line-height: 1;

  transform-origin: center;
  animation: spinFull 0.79s ease-in-out infinite;

  /* gradient text */
  background: var(--gradient-accent);
  background-size: 200% 200%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  padding: 0 6px;
}

/* Vertical stroke */
.spin-a::before {
  content: '';
  position: absolute;

  top: -5%;
  bottom: -5%;
  left: 48%;

  width: 2px;
  border-radius: 2px;

  background: var(--gradient-accent);
  background-size: 200% 200%;

  transform: translateX(-50%);
  opacity: 0.95;
  pointer-events: none;
}

/* Staggered animation delays */
.d1 { animation-delay: 0s; }
.d2 { animation-delay: 0.2s; }
.d3 { animation-delay: 0.4s; }

/* Spin animation */
@keyframes spinFull {
  0% {
    transform: rotateY(0deg);
  }

  42.86% {
    transform: rotateY(360deg);
  }

  100% {
    transform: rotateY(360deg);
  }
}
</style>